import Badge from './Badge.js';
export { default } from './Badge.js';
//# sourceMappingURL=index.js.map
